/**
 * DEFINE_COURSES drafts belong in the guided wizard. Rejected applications first need
 * the server's define_courses transition; submitting directly from a rejected state is invalid.
 */
const DRAFT_STATE = 'TAS.ApplicationState.DEFINE_COURSES';

/** Every application type routes to its own `-guided` wizard for the `new` flow;
 * both 4.x variants share the type-four wizard. */
const GUIDED_WIZARD_ROUTE_BY_TYPE: Record<string, string> = {
  'TAS.ProgramType.2': 'authenticated.tas.applications.type-two-guided.new',
  'TAS.ProgramType.3': 'authenticated.tas.applications.type-three-guided.new',
  'TAS.ProgramType.4.2': 'authenticated.tas.applications.type-four-guided.new',
  'TAS.ProgramType.4.3': 'authenticated.tas.applications.type-four-guided.new',
};

/**
 * The guided-wizard route an application should be redirected to, or `null` to let
 * the current route render.
 *
 * Shared by the legacy show route and the manage route so the two cannot disagree
 * about when a draft gets bounced — a second copy of this table is how they would
 * drift.
 */
export function guidedWizardRouteFor(
  typeClassification: string | null | undefined,
  state: string | null | undefined
): string | null {
  if (state !== DRAFT_STATE) {
    return null;
  }
  if (!typeClassification) {
    return null;
  }
  return GUIDED_WIZARD_ROUTE_BY_TYPE[typeClassification] ?? null;
}
